import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ApiResponse<T> {
    success: boolean;
    data?: T;
    message?: string;
    error?: string;
}

export interface Client {
    clienteId: number;
    cliente: string;
    tipoCliente?: string;
    activo?: boolean;
    fechaCreacion?: string;
}

@Injectable({
    providedIn: 'root'
})
export class ClientService {
    private apiUrl = `${environment.apiUrl}/v1/clients`;

    constructor(
        // eslint-disable-next-line no-unused-vars
        private http: HttpClient
    ) {}

    private getAuthHeaders(): HttpHeaders {
        const token =
            localStorage.getItem('access_token') ||
            localStorage.getItem('token');
        return new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        });
    }

    /**
     * Obtener cliente por ID usando el endpoint público de SQL Server
     */
    getClientById(id: number): Observable<Client> {
        const url = `${this.apiUrl}/info/${id}`;
        return this.http.get<Client>(url, { headers: this.getAuthHeaders() });
    }

    /**
     * Obtener todos los clientes
     */
    getClients(): Observable<ApiResponse<Client[]>> {
        const url = `${this.apiUrl}`;
        return this.http.get<ApiResponse<Client[]>>(url, { headers: this.getAuthHeaders() });
    }

    /**
     * Obtener clientes que tienen órdenes de servicio
     */
    getClientsWithOrderServices(): Observable<ApiResponse<Client[]>> {
        const url = `${this.apiUrl}/with-order-services`;
        return this.http.get<ApiResponse<Client[]>>(url, { headers: this.getAuthHeaders() });
    }
} 